import { render } from "./dictionaryInfo.vue?vue&type=template&id=1a397cca&scoped=true"
import script from "./dictionaryInfo.vue?vue&type=script&lang=js"
export * from "./dictionaryInfo.vue?vue&type=script&lang=js"

import "./dictionaryInfo.vue?vue&type=style&index=0&id=1a397cca&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a397cca"]])

export default __exports__